import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import AllActivities from './AllActivities';
import HabitActivities from './HabitActivities';
import PopularActivities from './PopularActivities';
import FilteredActivities from './FilteredActivities';
import TutorialActivities from './TutorialActivities';

const deps = {
  isLoadingChallengeData: state.challenge.isLoading.challengeData,
  selectedTag: state.challenge.log.selectedTag,
};

function Activities({
  isLoadingChallengeData,
  selectedTag,
}: typeof deps & ConnectedProps): React.ReactElement {
  if (isLoadingChallengeData) return null;

  if (selectedTag === 'all') {
    return <AllActivities />;
  }

  if (selectedTag === 'habits') {
    return <HabitActivities />;
  }

  if (selectedTag === 'popular') {
    return <PopularActivities />;
  }

  if (selectedTag === 'tutorial') {
    return <TutorialActivities />;
  }

  return <FilteredActivities />;
}

export default connect(deps, Activities);
